import { IOption } from '@/types/global.ts'
import {
  ISVGVisibilitySettings,
  TSVGVisibilitySettingsAction,
} from '@/pages/Dashboards/Charts/SVGChart/svgChart.types.ts'
import TrashButton from '@/shared/Buttons/TrashButton'
import FormField from '@/shared/Forms/FormField'
import SearchDropdownInput from '@/shared/Inputs/SearchDropdownInput'
import EquipmentDropdown from '@/pages/Equipment/components/Common/EquipmentDropdown'
import SvgChartSettingsCard from '@/pages/Dashboards/Charts/SVGChart/SvgChartSettingsSidePage/SvgChartSettingsCard'
import ParameterDropdown from '@/pages/Parameters/components/ParameterDropdown'
import SVGSettingsConditionDropdown from '@/pages/Dashboards/Charts/SVGChart/SvgChartSettingsSidePage/SvgChartConditionOperatorDropdown'
import NumberInput from '@/shared/Inputs/NumberInput'
import DropdownInput from '@/shared/Inputs/DropdownInput'
import ToolTip from 'src/shared/Common/Tooltip'
import PlayButton from '@/shared/Buttons/PlayButton'
import { IParameter } from '@/pages/Parameters/parameters.types'

interface IProps {
  settings: ISVGVisibilitySettings
  onChange: (index: number, value: any, key: string, nestedKey: 'visibility') => void
  onDelete: (index: number, nestedKey: 'visibility') => void
  onPlay: (settings: ISVGVisibilitySettings, key: 'visibility') => void

  nodeOptions: IOption<string>[]
  onNodeOptionHover: (id: string) => void

  index: number
}

const SvgChartVisibilitySettingsRow = (props: IProps) => {
  const handleChange = (val, name) => props.onChange(props.index, val, name, 'visibility')

  return (
    <div className="flex-lines gap16">
      <div className="inline-flex-gap flex-space-between width100">
        <h5 className="text-heading-5">Узел {props.index + 1}</h5>
        <div className="inline-flex-gap gap12">
          <ToolTip text="Проиграть превью" position="left" delay={50}>
            <PlayButton onClick={() => props.onPlay(props.settings, 'visibility')} size="default" />
          </ToolTip>
          <TrashButton onClick={() => props.onDelete(props.index, 'visibility')} />
        </div>
      </div>
      <div className="inline-flex-gap gap16">
        <FormField label="ID узла" required={true} fullWidth={true}>
          <SearchDropdownInput
            options={props.nodeOptions}
            selectedOption={props.settings.node_id as any}
            title="Выберите из списка"
            onSelect={handleChange}
            name="node_id"
            onOptionHover={props.onNodeOptionHover}
          />
        </FormField>
        <FormField label="Устройство" required={true} fullWidth={true}>
          <EquipmentDropdown
            value={props.settings.device_id}
            name="device_id"
            onChange={handleChange}
            placeholder="Выберите из списка"
          />
        </FormField>
      </div>
      <SvgChartSettingsCard>
        <div className="flex-lines gap12">
          <p className="text-caption" style={{ color: 'var(--text-description)' }}>
            Условие
          </p>
          <div className="inline-flex-gap gap16">
            <FormField label="Переменная" fullWidth={true}>
              <ParameterDropdown
                value={props.settings.parameter_id as IParameter['id']}
                name="parameter_id"
                onChange={handleChange}
                placeholder="Выберите из списка"
              />
            </FormField>
            <FormField label="Оператор" style={{ width: '100px', flexShrink: 0 }}>
              <SVGSettingsConditionDropdown
                title="="
                value={props.settings.condition}
                name="condition"
                onChange={handleChange}
              />
            </FormField>
            <FormField label="Значение" fullWidth={true}>
              <NumberInput
                value={props.settings.value}
                name="value"
                onChange={handleChange}
                fullWidth={true}
                placeHolder="Введите значение"
              />
            </FormField>
          </div>
        </div>
      </SvgChartSettingsCard>
      <SvgChartSettingsCard>
        <div className="flex-lines gap12">
          <div className="inline-flex-gap gap8 center">
            <p className="text-caption" style={{ color: 'var(--text-description)' }}>
              Видимость
            </p>
          </div>
          <FormField label="Отображение">
            <DropdownInput
              options={visibilityOptions}
              selectedOption={props.settings.action as any}
              title="Выберите действие"
              onSelect={handleChange}
              name="action"
            />
          </FormField>
        </div>
      </SvgChartSettingsCard>
    </div>
  )
}

const visibilityOptions: IOption<TSVGVisibilitySettingsAction>[] = [
  { title: 'Скрыть', value: 'hide' },
  { title: 'Мигать', value: 'blink' },
]

export default SvgChartVisibilitySettingsRow
